import StyledSelect from './StyledSelect';

export default StyledSelect;